import React, { useEffect, useRef, useState } from 'react';

const FadeInSection = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false); // Сбрасывает видимость при выходе из зоны видимости
        }
      },
      { threshold: 0.1 }, // Порог видимости 10%
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className={`fade-in ${isVisible ? 'visible' : 'invisible'}`}>
      {children}
    </div>
  );
};

export default FadeInSection;
